import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import HistoryModal from '../../components/HistoryModal';
import { formatDateString } from '../../components/FormattedDateTime/FormattedDateTime';
import DetailsViewer from '../../components/DetailsForm/DetailsViewer';

function PaymentInfo({ payment }) {
	const [showHistory, setShowHistory] = useState(false);

	const handleShowHistory = () => {
		setShowHistory(true);
	};

	const handleCloseHistory = () => {
		setShowHistory(false);
	};

	const verComprobante = () => {
		if (payment.comprobante && payment.comprobante.fileLink) {
			window.open(payment.comprobante.fileLink, '_blank', 'noopener,noreferrer');
		}
	};

	// Fields configuration array
	const paymentFields = [
		{
			label: 'Monto',
			key: 'amount',
			type: 'text',
			value: payment.amount || '',
		},
		{
			label: 'Fecha',
			key: 'date',
			type: 'text',
			value: formatDateString({
				dateValue: payment.date || '',
				dateFormat: 'DD/MM/YYYY',
			}),
		},
		{
			label: 'Moneda',
			key: 'currency',
			type: 'text',
			value: payment.currency || '',
		},
		{
			label: 'Deuda vinculada',
			key: 'debt',
			type: 'text',
			value: payment.debt ? payment.debt.customId : 'No tiene deuda vinculada',
			link: payment.debt ? `/AdminScreen/debts/debt/${payment.debt._id || payment.debt}` : null,
		},
		{
			label: 'Cuota Deuda',
			key: 'debtDue',
			type: 'text',
			value: payment.debtDue ? payment.debtDue.customId : 'No tiene cuota vinculada',
			link: payment.debtDue ? `/AdminScreen/debts/debt/${payment.debt?._id || payment.debt}/dues` : null,
		},
		{
			label: 'Carpeta',
			key: 'folder',
			type: 'text',
			value: payment.folder || '',
		},
		{
			label: 'Comprobante',
			key: 'comprobante',
			type: 'text',
			value: payment.comprobante && payment.comprobante.fileLink ? 'Ver comprobante' : 'No hay comprobante',
			button: payment.comprobante && payment.comprobante.fileLink ? {
				label: 'Ver Comprobante',
				onClick: verComprobante,
				hide: false,
			} : null,
			cols: 12,
		},
		{
			label: 'Observaciones',
			key: 'observations',
			type: 'textarea',
			value: payment.observations || '',
			cols: 12,
			rows: 10,
		},
	];

	return (
		<div className='p-3'>
			<Helmet>
				<title>Cobro</title>
			</Helmet>
			<HistoryModal
				model='payment'
				isHistory
				show={showHistory}
				handleClose={handleCloseHistory}
				id={payment._id}
			/>
			<DetailsViewer
				data={paymentFields}
				headerContent={
					<h2 className='text-center m-3 d-flex flex-column'>
						Información del Cobro
						<span
							onClick={handleShowHistory}
							style={{ cursor: 'pointer', textDecoration: 'underline' }}
							className='btn btn-link p-0'
						>
							Historial de cambios
						</span>
					</h2>
				}
			/>
		</div>
	);
}

export default PaymentInfo;

